<template>
  <div>
    <!-- Timesheet Reminder Dialog -->
    <v-dialog
      v-model="showTimesheetReminder"
      max-width="600"
      width="90vw"
      persistent
    >
      <v-card
        class="pa-4 pa-sm-6"
        color="secondary"
        rounded="xl"
      >
        <!-- Close button -->
        <v-btn
          icon
          variant="text"
          class="close-dialog-btn"
          @click="dismissReminder"
        >
          <v-icon color="white">
            mdi-close
          </v-icon>
        </v-btn>

        <v-card-title class="text-h4 text-sm-h4 text-xs-h5 pb-4 text-white d-flex align-center flex-wrap">
          <v-icon
            class="mr-2 mr-sm-3 mb-1 mb-sm-0"
            :size="$vuetify.display.xs ? 'default' : 'large'"
          >
            mdi-clock-alert-outline
          </v-icon>
          <span class="flex-grow-1">Timesheet Reminder</span>
        </v-card-title>
        <v-card-text class="text-h6 text-sm-h6 text-xs-subtitle-1 py-4 text-white">
          Jump to Timesheet?
        </v-card-text>
        <v-card-actions class="pt-4 flex-column flex-sm-row">
          <v-btn
            color="primary"
            variant="elevated"
            :size="$vuetify.display.xs ? 'default' : 'large'"
            class="px-4 px-sm-6 mb-2 mb-sm-0"
            block-on-xs
            @click="goToTimesheet"
          >
            <v-icon left>
              mdi-clock-check-outline
            </v-icon>
            Go to Timesheet
          </v-btn>
          <v-spacer class="d-none d-sm-flex" />
          <v-btn
            variant="text"
            :size="$vuetify.display.xs ? 'default' : 'large'"
            class="text-white"
            block-on-xs
            @click="dismissReminder"
          >
            Dismiss
          </v-btn>
          <v-btn
            variant="text"
            :size="$vuetify.display.xs ? 'default' : 'large'"
            class="text-white"
            block-on-xs
            @click="neverAskAgain"
          >
            Never ask again
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Employees Tab Button -->
    <v-btn
      class="employees-tab"
      elevation="0"
      @click="drawer = !drawer"
    >
      <v-icon
        left
        color="secondary"
      >
        mdi-briefcase
      </v-icon>
      <span class="text-uppercase text-secondary">Employees</span>
    </v-btn>

    <!-- Right Side Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      location="right"
      temporary
      width="800"
      class="employees-drawer"
    >
      <!-- Close button -->
      <v-btn
        icon
        class="close-btn"
        @click="drawer = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-list>
        <v-list-item>
          <v-list-item-title class="text-h6 mb-2">
            Employee Resources
          </v-list-item-title>
        </v-list-item>
        
        <v-divider />

        <!-- Timesheet Link -->
        <v-list-item
          prepend-icon="mdi-clock-time-four-outline"
          class="mt-2"
          @click="onTimesheetClick"
        >
          <v-list-item-title>
            Fill in your Timesheet
            <v-chip
              size="x-small"
              variant="outlined"
              color="secondary"
              class="ml-2"
            >
              Alt+T
            </v-chip>
          </v-list-item-title>
          <template #append>
            <v-icon size="small">
              mdi-open-in-new
            </v-icon>
          </template>
        </v-list-item>

        <!-- Visitor Request Link -->
        <v-list-item
          href="https://docs.google.com/forms/d/e/1FAIpQLSebBzBz3t60_444SdGu-K5F6FjQmb-9YzDWmDOBuidDCZQG2Q/viewform"
          target="_blank"
          prepend-icon="mdi-account-plus-outline"
          class="mt-2"
        >
          <v-list-item-title>Visitor Request</v-list-item-title>
          <template #append>
            <v-icon size="small">
              mdi-open-in-new
            </v-icon>
          </template>
        </v-list-item>

        <!-- Benefits and Payroll Link -->
        <v-list-item
          href="https://www.ktbsonline.com/"
          target="_blank"
          prepend-icon="mdi-cash-multiple"
          class="mt-2"
        >
          <v-list-item-title>Benefits and Payroll</v-list-item-title>
          <template #append>
            <v-icon size="small">
              mdi-open-in-new
            </v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'EmployeesDrawer',
  data() {
    return {
      drawer: false,
      showTimesheetReminder: false,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPress);
    this.checkTimesheetReminder();
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
  },
  methods: {
    // Cookie helper methods
    setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    },
    getCookie(name) {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let c = cookies[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    
    // Check if we should show the timesheet reminder
    checkTimesheetReminder() {
      const hasClickedTimesheet = this.getCookie('hasClickedTimesheet');
      const neverShowReminder = this.getCookie('neverShowTimesheetReminder');
      
      if (hasClickedTimesheet === 'true' && neverShowReminder !== 'true') {
        this.showTimesheetReminder = true;
      }
    },
    
    // Handle timesheet click
    onTimesheetClick() {
      this.setCookie('hasClickedTimesheet', 'true', 365);
      window.open('https://tsheets.intuit.com/', '_blank');
    },
    
    // Dialog actions
    goToTimesheet() {
      this.showTimesheetReminder = false;
      window.open('https://tsheets.intuit.com/', '_blank');
    },
    
    dismissReminder() {
      this.showTimesheetReminder = false;
    },
    
    neverAskAgain() {
      this.setCookie('neverShowTimesheetReminder', 'true', 365);
      this.showTimesheetReminder = false;
    },
    
    handleKeyPress(event) {
      // Check for Alt+E to toggle drawer
      if (event.altKey && event.key === 'e') {
        event.preventDefault();
        this.drawer = !this.drawer;
      }
      // Check for Alt+T to open timesheet link
      if (event.altKey && event.key === 't') {
        event.preventDefault();
        window.open('https://tsheets.intuit.com/', '_blank');
      }
      // Check for Enter when dialog is open
      if (event.key === 'Enter' && this.showTimesheetReminder) {
        event.preventDefault();
        this.goToTimesheet();
      }
      // Check for Escape to close drawer or dialog
      if (event.key === 'Escape') {
        if (this.showTimesheetReminder) {
          event.preventDefault();
          this.dismissReminder();
        } else if (this.drawer) {
          event.preventDefault();
          this.drawer = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.employees-tab {
  position: fixed;
  right: 0;
  bottom: 292px; /* ~100px + 192px (2 inches at 96dpi) */
  transform: rotate(-90deg);
  transform-origin: right bottom;
  border-radius: 8px 8px 0 0 !important;
  z-index: 1000;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 12px 8px !important;
  min-width: 40px;
  background-color: transparent !important;
  border: 2px solid #21a5a6 !important;
  transition: background-color 0.3s ease, transform 0.2s ease, border-color 0.3s ease;
}

.employees-tab:hover {
  background-color: rgba(33, 165, 166, 0.1) !important;
  transform: rotate(-90deg) translateX(-3px);
  border-color: #1a8384 !important;
}

.employees-tab span {
  writing-mode: horizontal-tb;
  transform: rotate(180deg);
}

.employees-drawer {
  padding-top: 20px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.close-dialog-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.v-list-item {
  cursor: pointer;
  transition: background-color 0.2s;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>